﻿import { createFileRoute } from "@tanstack/react-router";
import { RegistroVendasPage } from "@/paginas/pg_franquia/franquia-vendas-main";
import * as XLSX from "xlsx-js-style";
import { ARQUIVO as ARQ_vendas_dia } from "@/paginas/pg_franquia/franquia-vendas-vendas-dia";
import { ARQUIVO as ARQ_insumos_consumo } from "@/paginas/pg_insumos/insumos-consumo";
import { ARQUIVO as ARQ_vendaManual } from "@/paginas/pg_franquia/franquia-vendas-registro-manual";

export const Route = createFileRoute("/_authenticated/vendas")({
  head: () => ({
    meta: [
      { title: "Vendas — Milky Moo Palmares" },
      {
        name: "description",
        content: "Importe o PDV diário, visualize e exclua as vendas registradas em cada data.",
      },
      { property: "og:title", content: "Vendas — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Importe o PDV diário, visualize e exclua as vendas registradas em cada data.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: RegistroVendasPage,
});
